import { createFileRoute } from "@tanstack/react-router";

import AccessDeniedPage from "~/pages/AccessDeniedPage.tsx";

export const Route = createFileRoute("/access-denied")({
    component: AccessDeniedPage,
});
